import React from "react";

export default function Hero() {
    return (
        <section className="hero">
            <h1>Excellence in Dry Construction</h1>
            <p>Professional solutions in Steel Frame, Drywall and high-quality finishes for your project</p>
        </section>
    );
}